export default {
  init() {
    $('#header__info-question').on('click', function () {
      $('.header__info-question').toggleClass('active');
      $('.header__info-popup').toggleClass('active');
    })

    //height screen
    let vh = window.innerHeight * 0.01;

    document.documentElement.style.setProperty('--vh', `${vh}px`);

    $('.scroll-down').click(function () {
      $('body, html').animate({
        scrollTop: window.innerHeight,
      }, 400);
    });

    const menuButton = document.querySelector('.menu__button');
    const menuList = document.querySelector('.menu__list');
    const headerInfo = document.querySelector('.header__info');
    const header = document.querySelector('.header');
    const body = document.querySelector('body');

    menuButton.addEventListener('click', () => {
      let expanded = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', !expanded);
      menuButton.classList.toggle('menu__button--open');
      menuList.classList.toggle('menu__list--open');
      headerInfo.classList.toggle('header__info--open');
      header.classList.toggle('header--open');
      body.classList.toggle('overflow-hidden');
    });



    $(document).ready(function(){

      // открываем модальное окно при клике по контенту
      $('#list').click(function(){
        // popup_open('#myPopup');
      })

      // открываем модальное окно сразу при загрузки страницы
      popup_open('#myPopup');

      // Добавляем обработчик закрытия модального окна
      $(document).on('click', '.popup .close, .overflow-popup', function(){
        popup_close()
        return false;
      })

    })

    function popup_open(selector){
      if (selector.length){
        // $('html, body').animate({ scrollTop: 0 },'slow');
        $('.overflow-popup,'+selector).fadeIn();
        // $('body').addClass('overflow-hidden');
      }
    }
    function popup_close(){
      $('.overflow-popup, .popup').hide();
      // $('body').removeClass('overflow-hidden');
    }

    $('.header').parents().filter(function() {
      console.log($(this));
      console.log($(this).css('overflow'));
      return $(this).css('overflow') === 'hidden';
    });
  },

  // JavaScript to be fired on all pages, after page specific JS is fired
  finalize() {
  },
};
